import React from 'react'

import paginationStyles from './Pagination.module.css'
import { UpdateSearchParams } from '../../types/List'
import { Pagination } from '../../types/Pagination'

export type PageItemProps = {
  children?: React.ReactNode
  className?: string
  currentPage?: number
  updateSearchParams: UpdateSearchParams
  pagination: Pagination
  type: 'prev' | 'next' | 'page'
}

export function PageItem (props: PageItemProps) {
  const {
    children,
    className,
    currentPage,
    pagination,
    updateSearchParams,
    type
  } = props

  const mainClass =
    pagination.current === currentPage
      ? paginationStyles.selectedPage
      : paginationStyles.page

  const pageId = type === 'page' ? pagination.current : type

  const id =
    pagination.current === currentPage ? 'page-current' : `page-${pageId}`

  return (
    <a
      id={id}
      className={[mainClass, className].join(' ')}
      onClick={() => {
        updateSearchParams({
          pagination
        })
      }}
    >
      {children || pagination.current}
    </a>
  )
}

export default PageItem
